(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Collection-banner"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
  $('video.lazy.banner_collection_video source[data-src]').each(function() {
    var $video = $(this).closest('video');  // get parent video
    this.src = $(this).data('src');         // swap data-src -> src
    $video[0].load();                        // load the video
    $video[0].play().catch(function(){});   // autoplay (ignore errors)
  });
});

  } catch(e) { console.error(e); }
})();
})();
